module.exports = __webpack_public_path__ + "2b7d14270f1c81190d429a26fc18a6d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/content/irrigation2.jpg
// module id = 122
// module chunks = 1